import { useEffect } from 'react';
import { SITE_URL } from '@/data/blogSeoMetadata';
import {
  OG_DEFAULT_IMAGE_ALT,
  OG_DEFAULT_IMAGE_URL,
  OG_IMAGE_HEIGHT,
  OG_IMAGE_TYPE,
  OG_IMAGE_WIDTH,
} from '@/data/socialSeo';
import { detachPageSeo } from '@/utils/pageSeo';

export function usePublicSeo(path: string, title: string, description: string, schemas: object[] = [], noindex = false) {
  const serializedSchemas = JSON.stringify(schemas);
  useEffect(() => {
    const previousTitle = document.title;
    const restore = detachPageSeo();
    document.title = title;
    const elements: HTMLElement[] = [];
    const metadata = [
      ['name','description',description], ['property','og:title',title],
      ['property','og:description',description], ['property','og:url',`${SITE_URL}${path}`],
      ['property','og:type','website'], ['property','og:image',OG_DEFAULT_IMAGE_URL],
      ['property','og:image:type',OG_IMAGE_TYPE],
      ['property','og:image:width',String(OG_IMAGE_WIDTH)],
      ['property','og:image:height',String(OG_IMAGE_HEIGHT)],
      ['property','og:image:alt',OG_DEFAULT_IMAGE_ALT],
      ['name','twitter:card','summary_large_image'],
      ['name','twitter:title',title], ['name','twitter:description',description],
      ['name','twitter:image',OG_DEFAULT_IMAGE_URL],
      ['name','twitter:image:alt',OG_DEFAULT_IMAGE_ALT],
    ];
    if (noindex) metadata.push(['name','robots','noindex, follow']);
    for (const [attribute,key,content] of metadata) {
      const meta = document.createElement('meta'); meta.setAttribute(attribute,key); meta.content = content; elements.push(meta);
    }
    if (!noindex) {
      const canonical = document.createElement('link'); canonical.rel='canonical'; canonical.href=`${SITE_URL}${path}`; elements.push(canonical);
    }
    for (const value of JSON.parse(serializedSchemas)) {
      const script=document.createElement('script'); script.type='application/ld+json'; script.textContent=JSON.stringify(value); elements.push(script);
    }
    elements.forEach(element => { element.dataset.publicSeo='true'; document.head.appendChild(element); });
    return () => { elements.forEach(element => element.remove()); restore(); document.title=previousTitle; };
  }, [path,title,description,serializedSchemas,noindex]);
}
